import React from 'react';
import styles from './Footer.module.css';

function Footer() {
  return (
    <footer className={styles.footer}>
        <p>© 2024 - Gestion des Supports</p>
    </footer>
  );
}

export default Footer;
